import { fromJS } from "immutable";
import {
  USER_SUPERADMIN,
  STATUS_PUBLISHED_V1,
  STATUS_PUBLISHED_V2,
  STATUS_PENDINGAPPROVAL,
  STATUS_INCOMPLETE,
  ACTION_SET_AUTHORIZATION,
  ACTION_SET_LOGINDATA,
  ACTION_SET_BADPASSWORD,
  ACTION_SET_USER_LIST,
  ACTION_LOGOUT,
  ACTION_SET_CURRENTCLIENT,
  ACTION_SET_CURRENTUSER,
  ACTION_LOCK_FUTURE_DESTINATION,
  ACTION_SET_PLANINPUT,
  ACTION_OPEN_ACCOUNT_MENU,
  ACTION_UPDATE_EMAIL,
  ACTION_SET_CURRENTPLAN_CASHFLOW,
  ACTION_SET_FUTUREPLAN_CASHFLOW,
  ACTION_SET_FORGOT_PASSWORD,
  ACTION_SET_FINANCIAL_PROFESSIONAL,
  ACTION_SET_CURRENTFP_ID,
  ACTION_SET_TRUST_LIST,
  ACTION_APPEND_TO_TRUST_LIST,
  ACTION_CLEAR_FUTURE_CASH_FLOW,
  ACTION_OPEN_PASSWORD_CHANGE_SUCCESS_MODAL,
  ACTION_CLOSE_PASSWORD_CHANGE_SUCCESS_MODAL
} from "../shared/constants";
import {capitalize} from "../shared/shared";

const initialState = fromJS({
  loginInfo: {
    isLoggedIn: false,
    badPassword: { message: "", show: true },
    authorizationToken: null,
    userId: null,
    userName: null,
    advisorId: null,
    firmId: null,
  },
  currentUser: {
    name: "inStream SuperAdmin",
    id: 7,
    firstName: "inStream",
    lastName: "FP",
    authorization: USER_SUPERADMIN,
  },
  currentFPId: null,
  forgotPassword: "",
  ifwUsers: [],
  clientList: [
    {
      id: 0,
      firstName: "Client",
      lastName: "A",
      status: STATUS_PUBLISHED_V1,
      createDate: new Date(),
      lastUpdate: new Date(),
      financialProId: 12,
    },
    {
      id: 1,
      firstName: "Client",
      lastName: "B",
      status: STATUS_PUBLISHED_V2,
      createDate: new Date(),
      lastUpdate: new Date(),
      financialProId: 12,
    },
    {
      id: 2,
      firstName: "Client",
      lastName: "C",
      status: STATUS_PENDINGAPPROVAL,
      createDate: new Date(),
      lastUpdate: new Date(),
      financialProId: 7,
    },
    {
      id: 3,
      firstName: "Client",
      lastName: "D",
      status: STATUS_INCOMPLETE,
      createDate: new Date(),
      lastUpdate: new Date(),
      financialProId: 8,
    },
    {
      id: 4,
      firstName: "Client",
      lastName: "E",
      status: STATUS_INCOMPLETE,
      createDate: new Date(),
      lastUpdate: new Date(),
      financialProId: 8,
    },
  ],
  currentPlan: null,
  currentClient: null,
  lockFutureDestination: false,
  financialProfessional: {
    firstName: null,
    lastName: null,
    advisorId: null,
    email: null
  },
  dataPlanInput: {
    accounts: [],
    assumptions: {},
    fiaTransfers: [],
    goals: [],
    incomes: [],
    insuranceTransfers: [],
    rothTransfers: [],
    spendingGoals: []
  },
  isAccountModalOpen: false,
  isPasswordChangeSuccessModalOpen: false,
  currentFuturePlanCashFlow: {
    accountsSummary: [
      {
        clientAge: 0,
        coClientAge: 0,
        fiaAccountBalance: 0,
        fiaAccountGrossDistribution: 0,
        fiaIndexReturn: 0,
        insuranceCashValueReturn: 0,
        insuranceGrossDistribution: 0,
        insuranceNetCashValue: 0,
        portfolioReturns: 0,
        taxDeferredAccountBalance: 0,
        taxDeferredAccountGrossDistribution: 0,
        taxExemptAccountBalance: 0,
        taxExemptAccountGrossDistribution: 0,
        taxableAccountBalance: 0,
        taxableAccountGrossDistribution: 0,
        totalAccountValue: 0,
        year: 0
      }
    ],
    assumptions: {
      monthlyRetirementBudget: 0,
      nonQualifiedAssets: 0,
      preTaxAssets: 0,
      taxFreeAccounts: 0
    },
    cashFlowSummary: [
      {
        beginningAccountValue: 0,
        clientAge: 0,
        coClientAge: 0,
        cumulativeWealth: 0,
        excessIncome: 0,
        fiaAccountContribution: 0,
        fiaDistribution: 0,
        fiaIndexReturn: 0,
        grossTaxDeferredDistribution: 0,
        grossTaxExemptDistribution: 0,
        grossTaxableDistribution: 0,
        insuranceAccountDistribtuion: 0,
        insuranceCashValueReturn: 0,
        portfolioReturns: 0,
        taxDeferredAccountContribution: 0,
        taxExemptAccountContribution: 0,
        taxableAccountContribution: 0,
        totalInflow: 0,
        totalOutflow: 0,
        year: 0
      }
    ],
    cashInflow: [
      {
        clientAge: 0,
        coClientAge: 0,
        fiaWithdrawal: 0,
        other: 0,
        payroll: 0,
        pension: 0,
        socialSecurity: 0,
        taxDeferredDistributions: 0,
        taxExemptDistributions: 0,
        taxableDistributions: 0,
        totalInFlow: 0,
        year: 0
      }
    ],
    cashOutflow: [
      {
        capitalGainsTax: 0,
        clientAge: 0,
        coClientAge: 0,
        incomeTax: 0,
        retirementBudget: 0,
        socialSecurityTax: 0,
        totalOutFlow: 0,
        year: 0
      }
    ],
    fiaReport: [[]],
    insurance: [
      [
        {
          clientAge: 0,
          coClientAge: 0,
          distribution: 0,
          netCashValue: 0,
          netDeathBenefits: 0,
          premiumOutlay: 0,
          year: 0
        }
      ]
    ],
    successProbability: 0
  },
  trustList: []
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_SET_AUTHORIZATION:
      return state.setIn(["currentUser", "authorization"], action.value);
    case ACTION_SET_LOGINDATA:
      return state
        .setIn(["loginInfo", "isLoggedIn"], true)
        .setIn(["loginInfo", "badPassword"], false)
        .setIn(["loginInfo", "authorizationToken"], action.value.token)
        .setIn(["loginInfo", "userId"], action.value.userId)
        .setIn(["loginInfo", "userName"], action.value.userName)
        .setIn(["loginInfo", "advisorId"], action.value.advisorId);
    case ACTION_SET_CURRENTUSER:
      return state.setIn(["currentUser", "name"], action.value);
    case ACTION_SET_BADPASSWORD:
      return state.setIn(["loginInfo", "badPassword"], action.value);
    case ACTION_SET_FORGOT_PASSWORD:
      return state.set("forgotPassword", action.value)
    case ACTION_SET_USER_LIST:
      return state.setIn(["ifwUsers"], fromJS(action.value));
    case ACTION_SET_CURRENTCLIENT:
      return state.set("currentClient", fromJS(action.value));
    case ACTION_SET_CURRENTPLAN_CASHFLOW:
      return state.set("currentPlanCashFlow", fromJS(action.value));
    case ACTION_SET_FUTUREPLAN_CASHFLOW:
      return state.set("currentFuturePlanCashFlow", fromJS(action.value));
    case ACTION_CLEAR_FUTURE_CASH_FLOW:
      return state.set("currentFuturePlanCashFlow", null);
    case ACTION_LOGOUT:
      return state
        .setIn(["loginInfo", "isLoggedIn"], false)
        .setIn(["loginInfo", "badPassword"], false)
        .setIn(["loginInfo", "authorizationToken"], null)
        .setIn(["loginInfo", "userId"], null)
        .setIn(["loginInfo", "userName"], null);
    case ACTION_LOCK_FUTURE_DESTINATION:
      return state.setIn(["lockFutureDestination"], action.value)
    case ACTION_SET_PLANINPUT:
      return state.setIn(["planInput"], action.value.dataPlanInput);
    case ACTION_OPEN_ACCOUNT_MENU:
      return state.setIn(["isAccountModalOpen"], action.value);
    case ACTION_UPDATE_EMAIL:
      return state.setIn(["loginInfo", "userName"], action.value);
    case ACTION_SET_FINANCIAL_PROFESSIONAL:
      return state
        .setIn(['financialProfessional', 'firstName'], action.value.firstName)
        .setIn(['financialProfessional', 'lastName'], action.value.lastName)
        .setIn(['financialProfessional', 'advisorId'], action.value.advisorId)
        .setIn(['financialProfessional', 'email'], action.value.email);
    case ACTION_SET_CURRENTFP_ID:
      return state.set("currentFPId", action.value);
    case ACTION_SET_TRUST_LIST:
      return state.set("trustList", fromJS(action.value));
    case ACTION_APPEND_TO_TRUST_LIST:
      const data = capitalize(action.value);
      const trustList = state.get("trustList");
      const newTrustList = trustList.push(data);
      return state.set("trustList", newTrustList);
    case ACTION_OPEN_PASSWORD_CHANGE_SUCCESS_MODAL:
      return state.set("isPasswordChangeSuccessModalOpen", true);
    case ACTION_CLOSE_PASSWORD_CHANGE_SUCCESS_MODAL:
      return state.set("isPasswordChangeSuccessModalOpen", false);
  }
  return state;
};
